<script>
import { computed } from 'vue'

export default {
  // For the timetable inside, which scrolls with this container rather than the page while it
  // is in fullscreen, and has to follow it there.
  provide() {
    return { fullscreen: computed(() => this.isFullscreen) }
  },
  data() {
    return {
      isFullscreen: false,
    }
  },
  methods: {
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
      document.body.classList.toggle("app-fullscreen", this.isFullscreen)
    },
  },
  beforeUnmount() {
    document.body.classList.remove("app-fullscreen")
  }
};
</script>

<style>
/* The page header is fixed on small screens and would cover the fullscreen container */
.app-fullscreen .app-header {
  display: none;
}

.fullscreen-container.fullscreen {
  position: fixed;
  overflow: auto;
  inset: 0; /* no padding: the sticky time row and the bottom scrollbar stick to the window edges */
  z-index: 1025; /* above the sticky sidebar (1020), below modals (1055); dropdown menus inside stay on top of their own container */
}

.fullscreen-container.fullscreen > .text-end {
  padding: 0.5rem 0.5rem 0;
}
</style>

<template>
  <div class="fullscreen-container bg-body" :class="{ fullscreen: isFullscreen }">
    <div class="text-end">
      <button @click="toggleFullscreen" class="btn btn-outline-secondary">
        <span v-if="!isFullscreen" class="bi bi-arrows-fullscreen"></span>
        <span v-else class="bi bi-fullscreen-exit"></span>
      </button>
    </div>
    <slot></slot>
  </div>
</template>